/**
 * Utility functions for question handling
 */

/**
 * Strips HTML tags and returns plain text
 * @param html - HTML string to clean
 * @returns Plain text without HTML tags
 */
export const cleanHtmlToText = (html: string | null | undefined): string => {
  if (!html || typeof html !== "string") {
    return ""
  }

  // Remove HTML tags
  const textOnly = html.replace(/<[^>]*>/g, " ")

  // Decode HTML entities
  const decodedText = textOnly
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")

  return decodedText
}
